import { format, unwrapFunctionStore } from 'svelte-i18n';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const campaignsOverview = {
  popover: {
    title: 'Welcome to the Campaigns Manager!',
    description:
      "Manage all your company's campaigns in one place. Create, clone, edit, or delete campaigns easily—let's get started!",
    onNextClick: () => {
      const layoutBtns = document.querySelectorAll('div.toolbar > div.filters > div.display-options > div');

      if (layoutBtns[0].children[0].classList.contains('active')) {
        layoutBtns[0].children[1].click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.moveNext();
        }, 200);
      } else {
        GLOBAL_DRIVER_OBJECT.moveNext();
      }
    }
  }
};
